export var MenuItemTestIds = /*#__PURE__*/function (MenuItemTestIds) {
  MenuItemTestIds["ROOT"] = "menu-item-root";
  MenuItemTestIds["TITLE"] = "menu-item-title";
  MenuItemTestIds["TITLE_WRAP"] = "menu-item-title-wrap";
  MenuItemTestIds["AVATAR"] = "menu-item-avatar";
  MenuItemTestIds["FALLBACK_AVATAR"] = "menu-item-fallback-avatar";
  MenuItemTestIds["TEXT"] = "menu-item-text";
  MenuItemTestIds["USER_EMAIL"] = "menu-item-user-email";
  MenuItemTestIds["USER_PHONE"] = "menu-item-user-phone";
  MenuItemTestIds["RECOMMENDED_PRODUCTS"] = "menu-item-user-recommended-products";
  MenuItemTestIds["WATCH_LATEST_VIDEO"] = "menu-item-user-watch-latest-video-";
  MenuItemTestIds["EXPANDER"] = "menu-item-expander-button";
  MenuItemTestIds["USER_NAME"] = "menu-item-user-name";
  MenuItemTestIds["BENEFITS_LINK"] = "menu-item-benefits-link";
  return MenuItemTestIds;
}({});